/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function FisicaRelatividade() {
  return (
    <PaginasEspecificas posicao="5" endereco="/fisica" materia="Física" />
  );
}

export default FisicaRelatividade;
